import { SOURCE_COLORS, GLOBAL_FONT, SEMANTIC_COLORS, MARKETING_COLORS, MARKETING_BACKGROUNDS } from '../../core/constants/tokens-color.js';

/**
 * Below are Legacy names and should be avoided in use,
 * as they don't follow any particular naming or casing convention
 */ /**
 * @deprecated use SOURCE_COLORS in its place
 */ const sourceColors = SOURCE_COLORS;
/**
 * @deprecated use GLOBAL_FONT in its place
 */ const globalFont = GLOBAL_FONT;
/**
 * @deprecated use SEMANTIC_COLORS in its place
 */ const colors = SEMANTIC_COLORS;
/**
 * @deprecated use MARKETING_COLORS in its place
 */ const marketingBackgroundColors = MARKETING_COLORS;
/**
 * @deprecated use MARKETING_BACKGROUNDS in its place
 */ const marketingBackgroundTokenMapping = MARKETING_BACKGROUNDS;
/**
 * @deprecated use BACKGROUNDS in its place
 */ const SWAN_BACKGROUND_COLORS = {
    ATLANTIC: 'atlantic',
    CASPIAN: 'caspian',
    CELTIC: 'celtic',
    DARK_GREY: 'dark-grey',
    EMERALD: 'emerald',
    GRAPHITE: 'graphite',
    HOLIDAY_BEIGE_1: 'holiday-beige-1',
    HOLIDAY_GREEN_1: 'holiday-green-1',
    HOLIDAY_GREEN_2: 'holiday-green-2',
    HOLIDAY_RED_1: 'holiday-red-1',
    HOLIDAY_RED_2: 'holiday-red-2',
    KINGFISHER: 'kingfisher',
    MEDIUM_GREEN: 'medium-green',
    MEDIUM_GREY: 'medium-grey',
    OPAL: 'opal',
    PLATINUM: 'platinum',
    RIO: 'rio',
    TALAVERA: 'talavera',
    BLACK: 'black',
    BLACK_900: 'black-900',
    DARK_BLUE: 'dark-blue',
    DARK_GRAY: 'dark-gray',
    DISCOUNT: 'discount',
    EMERALD_100: 'emerald-100',
    EMERALD_700: 'emerald-700',
    GREEN_100: 'green-100',
    GREEN_700: 'green-700',
    GRAY_100: 'gray-100',
    GREY_100: 'grey-100',
    GREY_200: 'grey-200',
    GRAY_200: 'gray-200',
    GREY_300: 'grey-300',
    GRAY_300: 'gray-300',
    GREY_400: 'grey-400',
    GRAY_400: 'gray-400',
    GREY_500: 'grey-500',
    GRAY_500: 'gray-500',
    GREY_600: 'grey-600',
    GRAY_600: 'gray-600',
    GREY_700: 'grey-700',
    GRAY_700: 'gray-700',
    GREY_800: 'grey-800',
    GRAY_800: 'gray-800',
    GREY_900: 'grey-900',
    GRAY_900: 'gray-900',
    HOLIDAY: 'holiday',
    IRIS: 'iris',
    LIGHT_BLUE: 'light-blue',
    LIGHT_GRAY: 'light-gray',
    LIGHT_GREY: 'light-grey',
    LOADING_SHIMMER: 'loading-shimmer',
    MANDARIN: 'mandarin',
    MEDIUM_GRAY: 'medium-gray',
    MEDIUM_YELLOW: 'medium-yellow',
    PUMPKIN: 'pumpkin',
    RUM: 'rum',
    SANTORINI: 'santorini',
    SCARLET: 'scarlet',
    ULTRAMARINE: 'ultramarine',
    VIOLET: 'violet',
    WHITE: 'white',
    WHITE_900: 'white-900',
    YELLOW_700: 'yellow-700',
    TRANSPARENT: 'transparent'
};

export { SWAN_BACKGROUND_COLORS, colors, globalFont, marketingBackgroundColors, marketingBackgroundTokenMapping, sourceColors };
